<template>
  <v-card class="fill-height" width="100vw" :loading="loading">
    <v-card-text class="pt-0">
      <ShopStepper 
        v-model="shop"
        @onSubmit="createShop"
        :corporations="corporations"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import ShopStepper from './ShopStepper.vue';

export default{

  props: {
    loading: Boolean,
    corporation: Object,
    corporations: Array
  },

  data: () => ({
    is_valid: true,
    stepper: 1,
    shop: {
      name: null,
      address: null,
      description: null,
      logo_image: null,
      ip: null,
      port:null,
      token: null,
      payment_agent: {
        is_test: true,
        key: null,
        sector: null,
        currency: null,
        url: null,
        fail_url: null
      },
      order_type_map: ['DELIVERY']
    },
  }),
  
  computed:{
  },

  methods:{
    async createShop(){
      this.$emit('onSubmit', this.shop)
    },

    async searchCorporation(){
      ///
    }
  },

  components: {
    ShopStepper
  }
}
</script>